import { PetsAPI } from '@weave/schema-gen-ts/dist/schemas/pets-api/v1/pets_api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPetsV1Service = bindHTTP(PetsAPI);
